module.exports = __webpack_public_path__ + "img/profile-image.6e915de9.png";